import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SosIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sos"}/>
}
